function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" {...props}><path d="M6.427 6.687L7.851 12h4.198v.001A1 1 0 0 1 13 13h.006v5h-2v-4H7.05c-.553 0-.851-.441-1-1L4.496 7.204l1.931-.517zm-2.95 2.166L5.37 15h4.127v1H5a.5.5 0 0 1-.448-.278l-.03-.075-2-6.5.956-.294zM13.5 2.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm.506 1V6H15v1h-1.994V4.5h1zM4.996 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" fillRule="nonzero" /></svg>;
});